export default __webpack_public_path__ + "static/media/76t.198f04ba.jpg";